(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-explore-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.collection-explore-slider');

  if (sliders.length && typeof Splide !== 'undefined') {
    sliders.forEach(function (el) {
      new Splide(el, {
        type: 'loop',


        perPage: 3,
        perMove: 1,

        gap: '1rem',
        padding: '1rem',

        arrows: true,
        pagination: false,

        breakpoints: {
          1024: {
            perPage: 2
          },
          768: {
            perPage: 1
          }
        }
      }).mount();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.collection-explore-slider');
  if (el && typeof Splide !== 'undefined') {
    new Splide(el, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 1 }
      }
    }).mount();
  }
});

  } catch(e) { console.error(e); }
})();
})();
